/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Events_Filters_StorageInputs */

const es_billing_events_filters_storage = /** @type {(inputs: Billing_Events_Filters_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento`)
};

const en_billing_events_filters_storage = /** @type {(inputs: Billing_Events_Filters_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage`)
};

/**
* | output |
* | --- |
* | "Storage" |
*
* @param {Billing_Events_Filters_StorageInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_events_filters_storage = /** @type {((inputs?: Billing_Events_Filters_StorageInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Events_Filters_StorageInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_events_filters_storage(inputs)
	return en_billing_events_filters_storage(inputs)
});
export { billing_events_filters_storage as "billing.events.filters.storage" }